import React from 'react';
import { Page } from '../Common/Components/Page';
import { OperationGroupDetailsContent } from './Components/OperationGroupDetailsContent';

export const OperationGroupDetails = (): React.JSX.Element => (
  <Page title="Operation Group" accessKey={'operationGroups'} isSearchable={true}>
    <OperationGroupDetailsContent />
  </Page>
);
